export const RU: Record<string, string> = {
  选择分析信息: 'Выберите информацию для анализа',
  切换指标: 'Индикатор переключения',
  确定: 'Подтвердить',
  取消: 'Отмена',
  重置: 'Сбросить',
  请输入关键字搜索: 'Пожалуйста, введите поиск по ключевым словам',
  搜索: 'Поиск',
  恢复: 'Восстановить',
  '已选 {} 项': 'Выбран(-но) {} элемент(-а/-ов)',
  所选项: 'выбранные элементы',
  选择下钻维度: 'Выберите параметры детализации',
  恢复默认: 'Сбросить до первоначального состояния',
  搜索字段: 'Поисковое поле',

  // switcher
  行列切换: 'Конфигурация отображения строк, столбцов и значений',
  行头: 'Строки',
  列头: 'Колонки',
  值: 'Значения',
  展开子项: 'Отобразить дочерние элементы',

  // sort
  首字母: 'Алфавитная сортировка',
  手动排序: 'Ручная сортировка',
  其他字段: 'Другое поле',
  高级排序: 'Расширенная сортировка',
  设置顺序: 'Установить сортировку',
  可选字段: 'Необязательные поля',
  '按以下规则进行排序（优先级由低到高）':
    'Порядок, определеяемый следующими правилами (от низкого приоритета к высокому)',
  按: 'По',
  说明: 'Описание: ',

  // export
  复制原始数据: 'Копировать строковые данные',
  复制格式化数据: 'Копировать отформатированные данные',
  下载原始数据: 'Скачать строковые данные',
  下载格式化数据: 'Скачать отформатированные данные',
  操作成功: 'Операция успешно выполнена',
  操作失败: 'Операция завершилась неудачно',

  // strategy
  时间: 'Дата',
  指标: 'Мера',
  目标值: 'Целевое Значение',
};
